import type { ApiImage } from '@nutralab/api';

import { getImagePath } from './getImagePath';

const ABSOLUTE_URL_RE = /^https?:\/\//i;
// Served from the backend's storage by `app/storage/[...path]/route.ts`.
const STORAGE_PREFIX = '/storage/';

interface GetImageUrlOptions {
    /** The original file instead of the WebP copy: link previews and structured data, where not every reader shows WebP. */
    shouldUseOriginal?: boolean;
}

/**
 * The URL of a content image: the WebP copy when the backend has one, else the original file. Storage files get a
 * path on the storefront's own domain (`/storage/…`).
 */
export function getImageUrl(image: ApiImage, { shouldUseOriginal = false }: GetImageUrlOptions = {}): string {
    const path = typeof image === 'string' || shouldUseOriginal ? getImagePath(image) : (image.webp ?? image.original);

    if (ABSOLUTE_URL_RE.test(path) || path.startsWith(STORAGE_PREFIX)) {
        return path;
    }
    return `${process.env.NEXT_PUBLIC_STORAGE_BASE_URL}${path}`;
}
